const request = {}

request.createRequest = function (params) {
  return { note: params.pageInfoData.line1.remarks.data }
}
export default { request }
